module.exports = __webpack_public_path__ + "media/如何运用渗透定价策略.ab9f8b1a.mp4";